import _ from 'lodash';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { AgenturModel } from 'app/models/agentur.model';
import { AgenturStore } from '../agentur.store';
import { ISelectOpt } from 'app/components/common/Select';
import { formatKw, getFirstWeekOfCurrentYear } from 'app/utils';
import { AkumaPlanerModel, AgtAkumaPlanerStore } from '../agt.akumaplaner.store';
import { AkumaPlanerMultiGp26Model, AgtAkumaPlanerMultiGp26Store } from '../agt.akumaplaner.multigp26.store';
import colors from 'assets/scss/colors.module.scss';
import { BaseUiStore } from './base.ui.store';
import moment from 'moment';

export interface IAkumaPlanerDef {
	label: string;
	sort: number;
	path: string;
	color?: string;
}

// update akuma_planer_temp set art = 'nb' where art = 'Nicht bearbeitet'; -- fka om
// nu - Kunden mit Zuweisung aber nicht übertragen
//     update akuma_planer_temp set art = 'zagt' where art = 'Zuweisung: Agentur';
//     update akuma_planer_temp set art = 'zma' where art = 'Zuweisung: Mitarbeiter';

// berechnet
// ku - Kunden mit Zuweisung aber übertragen
// ku = zagt + zma
// gesamt = km + nb + nu + ku

// für gpwertung 6 mal im Jahr : ku /gesamt >= 0.5

export const AkumaPlanerArtSchema: IAkumaPlanerDef[] = [
	{
		label: 'Gesamt',
		path: 'gesamt',
		sort: 1,
		color: colors.turquoise,
	},
	{
		label: 'Kundenzuweisung und Übertragung >= 50%',
		path: 'gpWochen',
		sort: 1,
		color: colors.richTurquoise,
	},
	{
		label: 'Nicht bearbeitet',
		path: 'nb',
		sort: 1,
		color: colors.red,
	},
	{
		label: 'Keine Maßnahme',
		path: 'km',
		sort: 2,
		color: colors.greyLight,
	},
	{
		label: 'Kunden mit Zuweisung, nicht übertragen',
		path: 'nu',
		sort: 2,
		color: colors.blue,
	},
	{
		label: 'Kunden mit Zuweisung und übertragen',
		path: 'zu',
		sort: 1,
		color: colors.green,
	},
	{
		label: 'davon Zuweisung Agentur',
		path: 'zagt',
		sort: 3,
		color: colors.darkYellow,
	},
	{
		label: 'davon Zuweisung Mitarbeiter',
		path: 'zma',
		sort: 4,
		color: colors.purple,
	},
];

export class AgtAkumaPlanerVM {
	agt: AgenturModel;
	// @observable
	item?: AkumaPlanerModel;
	// @observable
	hasItem: boolean = false;
	multiGp26?: AkumaPlanerMultiGp26Model;

	constructor(agt: AgenturModel, item?: AkumaPlanerModel) {
		// makeObservable(this);
		this.agt = agt;
		this.item = item;
	}



	@computed
	get gesamt() {
		return this.item ? this.item.gesamt : 0;
	}
	@computed
	get wochen() {
		return this.item ? this.item.wochen : 0;
	}

	@computed
	get gpWochen() {
		return this.item ? this.item.gpWochen : 0;
	}


	@computed
	get gpNoWochen() {
		return this.item ? this.item.gpNoWochen : 0;
	}

	@computed
	get zu() {
		return this.item ? this.item.zu : 0;
	}

	@computed
	get km() {
		return this.item ? this.item.km : 0;
	}
	@computed
	get nb() {
		return this.item ? this.item.nb : 0;
	}
	@computed
	get nu() {
		return this.item ? this.item.nu : 0;
	}
	@computed
	get zagt() {
		return this.item ? this.item.zagt : 0;
	}
	@computed
	get zma() {
		return this.item ? this.item.zma : 0;
	}

	@computed
	get kwsAbove50Count() {
		return this.multiGp26 ? this.multiGp26.kwsAbove50Count : 0;
	}

	@computed
	get uebertragungsQuote() {
		// 	Übertragungsquote:
		// Nucht bearbeitet einblenden,
		// Kunden mit zuweisung UND übertragen / gesamt. Will always be quite low
		const q = this.gesamt > 0 ? (this.zu / this.gesamt) * 100 : 0;
		return Math.round(q * 100) / 100;
	}
}

export class AgtAkumaPlanerUiStore extends BaseUiStore<AgtAkumaPlanerVM> {
	name = 'AgtAkumaPlanerUiStore';
	agenturStore: AgenturStore;
	agtAkumaPlanerStore: AgtAkumaPlanerStore;
	agtAkumaPlanerMultiGp26Store: AgtAkumaPlanerMultiGp26Store;

	constructor(agenturStore: AgenturStore, agtAkumaPlanerStore: AgtAkumaPlanerStore, agtAkumaPlanerMultiGp26Store: AgtAkumaPlanerMultiGp26Store) {
		super();
		makeObservable(this);
		this.agtAkumaPlanerStore = agtAkumaPlanerStore;
		this.agtAkumaPlanerMultiGp26Store = agtAkumaPlanerMultiGp26Store;
		this.agenturStore = agenturStore;
	}
	onLogout() {
		this.agtAkumaPlanerStore.clear();
		this.agtAkumaPlanerMultiGp26Store.clear();
		this.agenturStore.onLogout();
	}

	filterByAgtId(agtId: number) {
		return this.allVmItems.filter((i) => i.agt.agtId === agtId);
	}

	filterByAgtIdandKw(agtId: number) {
		let items = this.currentKWItems.filter((i) => i.agt.agtId === agtId);
		return items;
	}

	@observable
	kws: number[] = [];

	@computed
	get kwsOpts(): ISelectOpt[] {
		return this.kws.map((kw) => {
			return {
				value: kw,
				label: formatKw(kw),
			};
		});
	}

	@computed
	get minKw(): number {
		if (this.minKwCurrent) {
			return this.minKwCurrent;
		}

		return 0;
	}




	@computed
	get maxKw(): number {
		if (this.maxKwCurrent) {
			return this.maxKwCurrent;
		}

		return 0;
	}

	@computed
	get firstWeek() {
		return this.kws[0];
	}
	@computed
	get lastWeek() {
		return this.kws[this.kws.length - 1];
	}

	@observable
	minKwCurrent?: number;

	@observable
	maxKwCurrent?: number;

	@observable
	allVmItems: AgtAkumaPlanerVM[] = [];


	@computed
	get currentKWItems() {
		return this.items;
	}

	async aggreagateAgtsByKw(minKw?: number, maxKw?: number, ssVmFilter?: string[]) {
		// load() first, so minKwCurrent/maxKwCurrent can serve as defaults. Without them an
		// undefined range queries ALL years and races against the filtered follow-up query.
		await this.load();
		minKw = minKw ?? this.minKwCurrent;
		maxKw = maxKw ?? this.maxKwCurrent;

		// Create a cache key based on the parameters
		const cacheKey = `loadAgtsByKw_${minKw || 'null'}_${maxKw || 'null'}_${ssVmFilter ? ssVmFilter.join('_') : 'null'}`;

		// Wrap the function with caching to prevent duplicate calls
		return this.withCache(
			cacheKey,
			async () => {
				let plans = await this.agtAkumaPlanerStore.aggregateByAgt(minKw, maxKw, ssVmFilter);
				const multiGp26Items = await this.agtAkumaPlanerMultiGp26Store.findAll();

				// Group plans by agtId in a single pass
				const plansByAgtId = new Map<number, AkumaPlanerModel>();
				plans.forEach((plan) => {
					plansByAgtId.set(plan.agtId, plan);
				});
				const multiGp26ByAgtId = new Map<number, AkumaPlanerMultiGp26Model>();
				multiGp26Items.forEach((item) => {
					multiGp26ByAgtId.set(item.agtId, item);
				});

				// Build results using direct Map lookup
				const res: AgtAkumaPlanerVM[] = this.items.map((vm) => {
					const p = plansByAgtId.get(vm.agt.agtId);
					const planerVm = new AgtAkumaPlanerVM(vm.agt, p);
					planerVm.multiGp26 = multiGp26ByAgtId.get(vm.agt.agtId);
					return planerVm;
				});
				runInAction(() => {
					this.items = res;
				});
				return this.items; // Return the items for potential caching
			},
			{
				cacheResult: true,
				measureTime: true,
				// Optionally, you could cache results for a short time:
				// cacheResult: true,
				// ttl: 60000 // Cache for 1 minute
			}
		);
	}



	@action
	async _baseLoad() {
		const promises = await Promise.all([this.agtAkumaPlanerStore.getDistinctKWs(), this.agenturStore.findAll(), this.agtAkumaPlanerMultiGp26Store.findAll()]);
		const kws = promises[0];
		let agts = promises[1].slice();
		const multiGp26Items = promises[2];

		runInAction(() => {
			this.kws = kws;
			// Set default start week to first week of current year instead of minimum week in data
			const firstWeekOfCurrentYear = getFirstWeekOfCurrentYear();
			this.minKwCurrent = this.kws.includes(firstWeekOfCurrentYear) ? firstWeekOfCurrentYear : _.min(this.kws);
			this.maxKwCurrent = _.max(this.kws);
		});

		const multiGp26ByAgtId = new Map<number, AkumaPlanerMultiGp26Model>();
		multiGp26Items.forEach((item) => {
			multiGp26ByAgtId.set(item.agtId, item);
		});

		console.time('prime load');
		const res: AgtAkumaPlanerVM[] = [];
		agts.forEach((agt) => {
			const vm = new AgtAkumaPlanerVM(agt, new AkumaPlanerModel(agt.agtId));
			vm.multiGp26 = multiGp26ByAgtId.get(agt.agtId);
			res.push(vm);
		});
		console.timeEnd('prime load');

		runInAction(() => {
			this.items = res;
			const max = _.maxBy(kws, 'kw');
			if (max) {
				this.datenStand = this.maxKwCurrent;
			}
		});

	}

	countPassedItemsForCurrentYear(agtId: number) {
		// TODO
		// const currYear = moment().year();
		// const currYearItems = this.items.filter((i) => i.agt.agtId === agtId && Math.floor(i.item / 100) === currYear && i.gpWochen >= 1);
		// return currYearItems.length;
		return 0;
	}

	@action
	async loadAkumaHistoryLast52Weeks(ids: number | number[]): Promise<
		{
			kw: string;
			kwRaw: number;
			wochen: number;
			gpWochen: number;
			gesamt: number;
			zu: number;
			uebertragungsQuote: number;
		}[]
	> {
		const isAggregated = Array.isArray(ids);
		const cacheKey = isAggregated
			? `AgtAkumaPlanerUiStore.loadAkumaHistoryLast52Weeks_${ids.sort().join('_')}`
			: `AgtAkumaPlanerUiStore.loadAkumaHistoryLast52Weeks_${ids}`;

		return this.withCache(
			cacheKey,
			async () => {
				// Ensure base data is loaded
				await this.load();

				// Calculate current KW (YYYYWW format)
				const now = moment();
				const currentYear = now.year();
				const currentWeek = now.isoWeek();
				const currentKw = currentYear * 100 + currentWeek;

				// Filter out future weeks
				const pastKws = this.kws.filter(kw => kw <= currentKw);

				// Get last 52 weeks of available past data
				const last52Kws = pastKws.slice(-52);

				// For aggregated view, load all agencies' data
				if (isAggregated) {
					const agtIds = ids as number[];

					// Load data for each week and aggregate
					const result = await Promise.all(
						last52Kws.map(async (kw) => {
							// Load all agencies' data for this week
							const allAgencyData = await this.agtAkumaPlanerStore.aggregateByAgt(kw, kw);

							let totalWochen = 0;
							let totalGpWochen = 0;
							let totalGesamt = 0;
							let totalZu = 0;

							agtIds.forEach((agtId) => {
								const agtData = allAgencyData.find((m) => m.agtId === agtId);
								if (agtData) {
									totalWochen += agtData.wochen || 0;
									totalGpWochen += agtData.gpWochen || 0;
									totalGesamt += agtData.gesamt || 0;
									totalZu += agtData.zu || 0;
								}
							});

							return {
								kw: formatKw(kw),
								kwRaw: kw,
								wochen: totalWochen,
								gpWochen: totalGpWochen,
								gesamt: totalGesamt,
								zu: totalZu,
								uebertragungsQuote: totalGesamt > 0 ? (totalZu / totalGesamt) * 100 : 0,
							};
						})
					);

					return result;
				} else {
					// Single agency view
					const agtId = ids as number;

					const result = await Promise.all(
						last52Kws.map(async (kw) => {
							const models = await this.agtAkumaPlanerStore.aggregateByAgt(kw, kw);
							const agtData = models.find((m) => m.agtId === agtId);

							return {
								kw: formatKw(kw),
								kwRaw: kw,
								wochen: agtData?.wochen || 0,
								gpWochen: agtData?.gpWochen || 0,
								gesamt: agtData?.gesamt || 0,
								zu: agtData?.zu || 0,
								uebertragungsQuote: agtData && agtData.gesamt > 0 ? (agtData.zu / agtData.gesamt) * 100 : 0,
							};
						})
					);

					return result;
				}
			},
			{
				cacheResult: true,
			},
		);
	}
}
